<template>
  <div>
    <h3>Rates</h3>
    <div v-if="isRateTheSame">
      <strong>
        <span class="rate">{{ formatCurrency(rateTable[0].price, currency, locale) }}</span>
      </strong>
      max of {{ rateTable[rateTable.length - 1].person }}
    </div>

    <v-data-table 
      v-else
      :items-per-page="-1" 
      hide-default-footer 
      disable-pagination
      :headers="headers" 
      :items="rateTable" 
      density="compact"
      class="rate-table"
    >
      <template #bottom></template>
      <template v-slot:item.price="{ value }">
        <strong>
          <span class="rate-blue">{{ formatCurrency(value, currency, locale) }}</span>
        </strong>
      </template>
    </v-data-table>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { formatCurrency } from '~/utils/index';

const props = defineProps({
  rateTable: {
    type: Array,
    required: true
  },
  currency: {
    type: String,
    required: true
  },
  locale: {
    type: String,
    required: true
  }
});

const isRateTheSame = computed(() => 
  props.rateTable.every(value => value.price === props.rateTable[0].price)
);

const headers = [
  {
    align: 'center',
    key: 'person',
    sortable: false,
    title: 'Participants',
    headerProps: {
      style: 'font-weight: 1000'
    }
  },
  {
    align: 'center',
    key: 'price',
    sortable: false,
    title: 'Total Rate',
    headerProps: {
      style: 'font-weight: 1000'
    }
  }
];
</script>

<style scoped>
.rate-table {
  max-height: 400px;
  overflow-y: auto;
}

.rate {
  font-size: 1.25rem;
  color: #1976D2;
}

.rate-blue {
  color: #1976D2;
}
</style> 